import { useSelector } from "react-redux";
import { UAParser } from "ua-parser-js";

import { DesignToken, Text } from "@livechat/design-system-react-components";

import Flex from "components/layout/Flex";
import { IAuthor } from "hooks/use-audit-log";
import { IWithAgentsState, selectAgent, selectAgentByAccountId } from "store/entities/agents";
import { withVar } from "themes/helpers";

export type AuthorCellProps = Partial<IAuthor>;

// FIXME: Fix this the next time the file is edited.
// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
export function AuthorCell({ ID = "", type, ip, userAgent, accountID }: AuthorCellProps) {
  const ua = UAParser(userAgent);
  const agent = useSelector((state: IWithAgentsState) => selectAgent(state, ID));
  const targetAgent = accountID && useSelector((state: IWithAgentsState) => selectAgentByAccountId(state, accountID));
  switch (type) {
    case "agent":
      return (
        <Flex column>
          <Text>{agent?.name}</Text>
          <Text customColor={withVar(DesignToken.ContentBasicSecondary)} size="sm" data-testid={`${agent?.email}`}>
            {agent?.email}
            <br />
            <Text size="sm">
              {ua.browser.name || "Unknown browser"} on {ua.os.name ? ua.os.name : "unknown system"}
            </Text>
            {ip && `IP: ${ip}`}
          </Text>
        </Flex>
      );
    default:
      return (
        <Flex column>
          <Text>System (by HelpDesk)</Text>
          {ip ? (
            <Text customColor={withVar(DesignToken.ContentBasicSecondary)} size="sm">
              {ip}
            </Text>
          ) : null}
          {targetAgent ? (
            <Text customColor={withVar(DesignToken.ContentBasicSecondary)} size="sm">
              {targetAgent.name}
            </Text>
          ) : null}
        </Flex>
      );
  }
}
